import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

@Component({
  selector: 'lib-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.css']
})
export class ErrorAlertComponent implements OnInit {
  isEng = true;

  config = {
    title: 'Oops!',
    text: 'Poor lighting or undetectable gaze',
    reload: 'Reload',
    tryLater: 'Try later',
  };

  constructor(
    private modal: NgbActiveModal,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    console.log('ErrorAlertComponent modal');
  }

  onClose() {
    this.modal.close();
  }

  onReload() {
    window.location.reload();
  }

  onTryLater() {
    this.router.navigate(['/'])
    .then(() => {
      this.modal.close();
    });
  }
}
